// extracted by mini-css-extract-plugin
module.exports = {"feedbackLink":"feedback_link__feedbackLink___hrMXp"};